import type { Language } from '@/api/types'

/**
 * Lot 34 (#335) : la langue de l'écran. L'équipe lit toujours le français ;
 * le portail lit celle du contact (`PortalMe.language`), posée par son cadre
 * avant de rendre ses pages, qui sont remontées quand elle change.
 *
 * Une valeur du module plutôt qu'un contexte : les formats de date et de
 * montant (`lib/format.ts`) et les phrases des refus (`lib/*`) sont appelés
 * hors des composants, et une personne n'est jamais à la fois dans l'équipe
 * et au portail dans le même onglet.
 */
export type Locale = Language

let current: Locale = 'fr'

export function currentLocale(): Locale {
  return current
}

export function setCurrentLocale(locale: Locale): void {
  current = locale
}

/** La locale `Intl` : les dates et les nombres en `fr-CA` ou `en-CA`. */
export function intlLocale(locale: Locale = current): string {
  return locale === 'en' ? 'en-CA' : 'fr-CA'
}

/** La langue du navigateur, quand on ne connaît pas encore la personne (connexion, espace fermé). */
export function browserLocale(): Locale {
  const languages = typeof navigator === 'undefined' ? [] : [...navigator.languages]
  const first = languages[0] ?? (typeof navigator === 'undefined' ? '' : navigator.language)
  return first.toLowerCase().startsWith('en') ? 'en' : 'fr'
}
